import { GOALTYPECONSTANTS } from '_constants';
import { InputField, SelectField } from 'components/molecules/formFields';
import React from 'react';
import { useGoals } from 'utils/hooks/ctx-hooks';

import { FormBuilder } from './form-builder';
import { GoalFormProps } from './types';

export const GoalForm = ({
  disableAll = false,
  hasLongTermGoal,
  initValue,
  onBack,
  onSubmit,
}: GoalFormProps) => {
  const { goalTypeOptions } = useGoals();

  const formFields = [
    {
      component: SelectField,
      fieldKey: 'goalType',
      label: 'GOAL TYPE',
      options: goalTypeOptions,
      disabledOptions: hasLongTermGoal ? [GOALTYPECONSTANTS.LONG] : [],
    },
    {
      component: InputField,
      fieldKey: 'title',
      label: 'GOAL TITLE',
      validation: {
        validate: (currentValue: string) =>
          currentValue.trim().length > 0 || 'Goal Title must be provided',
      },
    },
    {
      component: InputField,
      fieldKey: 'description',
      label: 'DESCRIPTION',
      type: 'textarea',
      multiline: true,
      rows: 4,
    },
  ];

  return (
    <FormBuilder
      disabled={disableAll}
      initValues={initValue}
      formFields={formFields}
      onBack={onBack}
      onSubmit={onSubmit}
      backLabel="Cancel"
      submitLabel="Save"
    />
  );
};
